import type { IconData } from '@stacksjs/iconify-core'

export const twitter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M741 170v22q0 56-14 113t-41 111t-69 101t-94 82t-119 55t-144 20q-72 0-137-20T0 598q19 3 40 3q60 0 114-20t97-53q-56-1-99-34t-60-84q16 3 32 3q22 0 45-5q-29-6-54-21t-43-37t-28-50t-11-59v-2q36 21 77 22q-35-23-55-60t-21-81q0-23 6-45t17-41q63 78 153 125t196 52q-2-9-3-19t-1-19q0-35 14-66t36-54t54-37t65-13q37 0 69 14t55 40q57-12 108-41q-10 29-29 53t-46 40q51-6 97-26q-34 52-84 87\"/>",
  "width": 830,
  "height": 810,
  "viewBox": "0 0 830 810"
}

export default twitter
